import React from 'react';
import { fontSize } from '../../..';
interface IFlowDetailsProps {
  flowName: string;
  currentValue: number;
  min: number;
  max: number;
}
function FlowDetails({ flowName, currentValue, min, max }: IFlowDetailsProps) {
  const rangeText =
    min === max ? `${currentValue} of ${min}` : `${currentValue} of ${min} to ${max}`;
  return (
    <React.Fragment>
      <span
        style={{
          fontSize: fontSize.large,
          paddingLeft: '5px',
          color: '#484848',
        }}
      >
        {flowName}
      </span>
      <span
        style={{
          textAlign: 'center',
          fontSize: '11px',
          color: '#999999',
          paddingTop: '3px',
        }}
      >
        {rangeText}
      </span>
    </React.Fragment>
  );
}

export default FlowDetails;
